var second = 1000,
minute = second * 60,
hour = minute * 60,
day = hour * 24;
var countDown = new Date(window.timer_end_date).getTime(),
x = setInterval(function() {
var daysEl = document.querySelector('.js-timer-days'),
    hoursEl = document.querySelector('.js-timer-hours'),
    minutesEl = document.querySelector('.js-timer-minutes'),
    secondsEl = document.querySelector('.js-timer-seconds');

// Timer markup is not on this page, or no end date was set — stop the interval.
if (!daysEl || !hoursEl || !minutesEl || !secondsEl || isNaN(countDown)) {
  clearInterval(x);
  return;
}

var now = new Date().getTime(),
    distance = countDown - now;

// Helper function to pad single digits with a leading zero
function pad(num) {
  return num < 10 ? '0' + num : num;
}

if (distance <= 0) {
  clearInterval(x); // Stop the countdown
  daysEl.innerText = "00";
  hoursEl.innerText = "00";
  minutesEl.innerText = "00";
  secondsEl.innerText = "00";
} else {
  daysEl.innerText = pad(Math.floor(distance / day));
  hoursEl.innerText = pad(Math.floor((distance % day) / hour));
  minutesEl.innerText = pad(Math.floor((distance % hour) / minute));
  secondsEl.innerText = pad(Math.floor((distance % minute) / second));
}
}, second);